// extracted by mini-css-extract-plugin
export default {"toggleContainer":"List_toggleContainer__X+arc"};